export const getIdProvinsi = (provinces, province) => {
    return provinces.filter(item => item.nama === province)
}